import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=37270e8c&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=37270e8c&prod&scoped=true&lang=scss"
import style1 from "./BlogPost.vue?vue&type=style&index=1&id=37270e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37270e8c",
  null
  
)

export default component.exports